module.exports = __webpack_public_path__ + "static/media/renewal-macbook.1c481467.png";